/**
 * The type of notification
 */
export enum NotificationType {
  /**
   * User received a call but did not answered it.
   * For Seniors and Caregivers.
   */
  MissedCall = 'missed-call',

  /**
   * Request target user approval to send a relationship invite.
   * For Seniors.
   */
  RelationshipInviteRequest = 'relationship-invite-request',

  /**
   * Notifies the user about the decision taken over `RelationshipInviteRequest`.
   * For Caregivers.
   */
  RelationshipInviteRequestResult = 'relationship-invite-request-result',

  /**
   * Request to obtain a caregiver administrator role.
   * For Seniors.
   */
  CaregiverAdministratorRoleRequest = 'caregiver-administrator-role-request',

  /**
   * Notifies the user about the decision taken over `CaregiverAdministratorRoleRequest`
   * For Caregivers.
   */
  CaregiverAdministratorRoleRequestResult = 'caregiver-administrator-role-request-result',

  /**
   * Senior has no more caregiver administrators. Senior is it's own administrator now.
   * For Seniors.
   */
  NoCaregiversAdministrators = 'no-caregivers-administrators',

  /**
   * Update about a relationship role change.
   * For Seniors and Caregivers.
   */
  RelationshipRoleChange = 'relationship-role-change',

  /**
   * Update about the end of a relationship.
   * For Seniors and Caregivers.
   */
  RelationshipEnd = 'relationship-end',

  /**
   * Personal data sharing preferences were changed.
   * For Caregivers.
   */
  PersonalDataSharingPreferencesChange = 'personal-data-sharing-preferences-change',

  /**
   * SOS Request from Senior users.
   * For Caregivers.
   */
  SosRequest = 'sos-request',

  /**
   * Informs seniors's devices that a new reminder was created or updated.
   * For Seniors.
   */
  SetReminder = 'set-reminder',

  /**
   * Presents to a Caregiver the response to a reminder from a senior.
   * For Caregivers.
   */
  ReminderResponse = 'reminder-response',

  /**
   * An invitation to belong to a family
   */
  RelationshipInvite = 'relationship-invite',

  /**
   * A Video Message sent from a user to another user.
   * For Seniors and Caregivers.
   */
  VideoMessage = 'video-message',

  /**
   * A drawing sent from a senior to a caregiver.
   * For Caregivers.
   */
  DrawingSent = 'drawing-sent',

  /**
   * Senior user shared a drawing in all its caregivers.
   * For Caregivers.
   */
  DrawingShared = 'drawing-shared',

  /**
   * A senior user just signed in.
   * For Caregivers.
   */
  UserSignedIn = 'user-signed-in',

  /**
   * User tried to access Sioslife without a valid license.
   * For Caregivers.
   */
  WithoutLicense = 'without-license',

  /**
   * User sent a photo to another user.
   * For Seniors and Caregivers.
   */
  PhotoSent = 'photo-sent',

  /**
   * User shared a photo in the family album.
   * For Seniors and Caregivers.
   */
  PhotoShared = 'photo-shared',

  /**
   * Media Processing Status changed.
   * For Seniors and Caregivers.
   */
  MediaProcessingStatus = 'media-processing-status',

  /**
   * An invitation to establish an affiliation with an Entity.
   * For Caregivers.
   */
  AffiliationInvite = 'affiliation-invite',

  /**
   * User sent a video to another user.
   * For Seniors and Caregivers.
   */
  VideoSent = 'video-sent',

  /**
   * User shared a video in the family album.
   * For Seniors and Caregivers.
   */
  VideoShared = 'video-shared',

  /**
   * Senior ask for media to caregiver.
   * For Caregivers.
   */
  MediaEmpty = 'media-empty',

  /**
   * A painting sent from a senior to a caregiver.
   * For Caregivers.
   */
  PaintingSent = 'painting-sent',

  /**
   * Senior user shared a painting in all its caregivers.
   * For Caregivers.
   */
  PaintingShared = 'painting-shared',

  /**
   * A new occurrence is assigned to logged-in professional.
   * For Professionals.
   */
  NewOccurrenceAssigned = 'new-occurrence-assigned',

  /**
   * A new occurrence is created.
   * For Professionals.
   */
  NewOccurrence = 'new-occurrence',
}
